import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { QrCode, Printer, MapPin, Info } from "lucide-react";

export default function BusinessPoster({ business, onGoToQRs }) {
  const [directoryName, setDirectoryName] = useState(null);

  useEffect(() => {
    if (!business?.postal_code) return;
    api.get(`/directory/search?postal_code=${business.postal_code}`)
      .then((r) => setDirectoryName(r.data.directory_name))
      .catch(() => {});
  }, [business?.postal_code]);

  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const directoryUrl = `${baseUrl}/directorio/${business?.postal_code || ""}`;

  return (
    <div className="space-y-6">
      {/* Informative card redirecting to Mis QR */}
      <div className="bg-white border border-border rounded-2xl p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-xl bg-[#F5F3FF] border border-[#DDD6FE] grid place-items-center shrink-0">
            <QrCode className="w-6 h-6 text-[#7C3AED]" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-display text-2xl tracking-tight">Tu cartel imprimible del directorio</h3>
            <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
              Todos tus códigos QR e imprimibles (incluyendo tu cartel del directorio
              <strong> {directoryName ? `"${directoryName}"` : `(CP ${business?.postal_code})`}</strong>, tu menú digital, lealtad y rifa) se encuentran centralizados y listos para imprimir en la sección <strong>Mis QR</strong>.
            </p>

            <div className="mt-4 flex items-start gap-2 bg-[#F5F3FF] border border-[#DDD6FE] rounded-xl p-3.5 text-xs">
              <Info className="w-4 h-4 mt-0.5 text-[#7C3AED] shrink-0" />
              <span className="text-zinc-700">
                <strong>Recomendación:</strong> Pégalo en la entrada de tu negocio, en la caja o en la vitrina. Cuando tus clientes lo escaneen, verán tu anuncio en el directorio de tu colonia.
              </span>
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-3">
              {onGoToQRs && (
                <Button onClick={onGoToQRs} className="btn-primary rounded-full" data-testid="poster-go-to-qrs-btn">
                  <QrCode className="w-4 h-4 mr-2" /> Ver en Mis QR →
                </Button>
              )}
              <a
                href={directoryUrl}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 border border-border rounded-full px-4 py-2 text-sm font-medium hover:bg-muted transition-colors"
                data-testid="poster-preview-link"
              >
                <MapPin className="w-4 h-4 text-[#7C3AED]" /> Ver mi directorio en vivo
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
